<template>
  <div class="row">
    <div class="col-4 lbl">
      <label>Entité :</label>
    </div>
    <div class="col-4">
      <Dropdown
        v-model="endroitLocal.entiteCle"
        :options="entiteLibelles"
        :showClear="true"
        :filter="true"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Site :</label>
    </div>
    <div class="col-4">
      <Dropdown
        v-model="endroitLocal.siteCle"
        :options="siteLibelles"
        :showClear="true"
        :filter="true"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Description :</label>
    </div>
    <div class="col-4">
      <InputText type="string" v-model="endroitLocal.description" />
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Regroupement des endroits :</label>
    </div>
    <div class="col-4">
      <Dropdown
        v-model="endroitLocal.regroupementEndroitCle"
        :options="regroupementEndroitLibelles"
        :showClear="true"
        :filter="true"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  props: ['endroit'],
  data() {
    return {
      entiteLibelles: [],
      siteLibelles: [],
      regroupementEndroitLibelles: [],
      endroitLocal:{...this.endroit}
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('pilotage/rechercherListeEntiteAction')
    .then((res) => {
        this.entiteLibelles = res.data;
    });
    this.$store.dispatch('pilotage/obtenirRegroupementsEndroitsAction')
    .then((res) => {
      this.regroupementEndroitLibelles = res.data;
    })
    if (this.endroitLocal.entiteCle != null) {
      this.$store.dispatch('dossier/onChangeEntityAction', {
        libelleChange: 'Site',
        nouvelleValeur: [this.endroitLocal.entiteCle]
      })
      .then((res) => {
        this.siteLibelles = res.data;
      });
    }
  },
  methods: {
    getEndroitLocal() {
      return this.endroitLocal;
    }
  },
  watch: {
    'endroitLocal.entiteCle'(val) {
      if (val != null) {
        this.$store.dispatch('dossier/onChangeEntityAction', {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        })
        .then((res) => {
          this.siteLibelles = res.data;
          this.endroitLocal.siteCle = null;
        });
      }else {
        this.endroitLocal.siteCle = null;
        this.siteLibelles = [];
      }
    }
  }
}
</script>
